<template>
    <div class="col-md-8" style="margin-left: 20%">
        <br><br>
        <br><br>
        <div class="alert alert-success" role="alert">
            Έχετε αποσυνδεθεί με επιτυχία. Θα ανακατευθυνθείτε στην σελίδα σύνδεσης σε 3 δευτερόλεπτα.
        </div>
    </div>
</template>

<script>
    export default {
        name: "Logout",

        created() {
            this.$store.dispatch('logout');
            let that = this;
            setTimeout( () => that.$router.push({ path: '/login'}), 3000);
        }
    }
</script>

<style scoped>

</style>